import {BaseService} from './Core/BaseService';
import {BaseSearchableService} from "./Core/BaseSearchableService";
import {service as ConservationActionTypeService} from "./ConservationActionTypeService";
import {service as SurveyTypeService} from "./SurveyTypeService";

class SurveyService extends BaseSearchableService {
    constructor() {
        super();

        this.publishedSurveyTypeCache = new Map();
    }

    get ModelName() { return "Survey"; }
    get PrimaryKeyProperty() { return "surveyId"; }
    get TitleProperty() { return "name"; } // TODO: Make this a property of the surveyType
    get Url() { return super.Url + "/surveys"; }

    GetTitle(model, defaultTitle = "") {
        const surveyKind = model.organizationId === null ? 'Default' : 'Custom';
        const conservationAction = ConservationActionTypeService.CachedValueById(model.conservationActionTypeId)?.result;
        const surveyType = SurveyTypeService.CachedValueById(model.surveyTypeId)?.result;
        if(conservationAction && surveyType) {
            return `${conservationAction.name} - ${surveyType.name} (${surveyKind})`;
        } else {
            return 'N/A';
        }
    }
    
    GetSurveysByConservationActionId(surveyTypeId = null, conservationActionId = null) {
        return this.SendRequest(BaseService.GET, {
            surveyTypeId,
            conservationActionId
        });
    }

    GetPublishedSurveyTypeCodesByConservationActionId(conservationActionId = null) {
        const cacheKey = conservationActionId;

        if (this.publishedSurveyTypeCache.has(cacheKey)) {
            return this.publishedSurveyTypeCache.get(cacheKey);
        }

        const requestPromise = this.SendRequest(BaseService.POST, {
            conservationActionId
        }, null, '/published').catch((error) => {
            this.publishedSurveyTypeCache.delete(cacheKey);
            throw error;
        });

        this.publishedSurveyTypeCache.set(cacheKey, requestPromise);

        return requestPromise;
    }

    GetSurveys(surveyTypeId = null, conservationActionTypeId = null, organizationId = null) {
        let request = {};

        if(surveyTypeId) {
            request.surveyTypeId = surveyTypeId;
        }
        if(conservationActionTypeId) {
            request.conservationActionTypeId = conservationActionTypeId;
        }
        if(organizationId) {
            request.organizationId = organizationId;
        }

        return this.SendRequest(BaseService.GET, request);
    }

    UpdateSurvey(survey) {
        return this.SendRequest(BaseService.PUT, survey);
    }

    CreateSurvey(survey) {
        return this.SendRequest(BaseService.POST, survey);
    }

    DeleteSurvey(surveyId) {
        return this.SendRequest(BaseService.DELETE, surveyId);
    }
}

export const service = new SurveyService();
